/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { Injectable } from '@angular/core';
import { I18nService } from '@dm/core';

@Injectable({ providedIn: 'root' })
export class AccessUserStrService {
    get = this.i18nService.get;

    i18n = {
        /**
         * label
         */
        // 名称
        name: this.get('common.name_column'),
        vStoreLab: this.get('common.owningVstore_lab'),
        description: this.get('common.description_column'),
        mainGroup: this.get('service.accessUser_term_mainGroup_lab'),
        basicInfoLab: this.get('common.basicInfo_title'),
        // ID
        id: this.get('common.ID_column'),

        // 按钮
        yes: this.get('common.yes_lab'),
        no: this.get('common.no_lab'),
        ok: this.get('common.confirm_button'),
        cancel: this.get('common.cancel_button'),
        close: this.get('common.close_button'),

        createBtn: this.get('common.create_button'),
        deleteBtn: this.get('common.delete_button'),
        modifyBtn: this.get('common.modify_button'),
        closeBtn: this.get('common.close_button'),
        operationBtn: this.get('common.operation_button'),

        // 标题
        // UNIX用户
        unixUser: this.i18nService.get('service.accessUser_UNIXUsers_lab'),
        // windows用户
        windowsUser: this.i18nService.get('service.accessUser_WindowsUsers_lab'),
        // 用户映射
        userMapping: this.i18nService.get('service.userMapping_task_title'),
        // 本地认证用户
        localAuthUser: this.i18nService.get('service.accessUser_term_localAuthUser_lab'),
        // 本地认证用户组
        localAuthGroup: this.i18nService.get('service.accessUser_localAuthUserGroup_lab'),
        // 创建用户
        createUserTitle: this.get('service.accessUser_term_localAuthUser_create_title'),
        // 修改用户
        modifyUserTitle: this.get('service.accessUser_term_localAuthUser_modify_title'),
        // 创建用户组
        createGroupTitle: this.get('service.accessUser_term_localAuthUserGroup_create_title'),
        // 修改用户组
        modifyGroupTitle: this.get('service.accessUser_term_localAuthUserGroup_modify_title'),
        // 选择主组
        selecetPrimaryGroupTitle: this.get('service.accessUser_term_chooseMainGroup_title'),

        // 展示文本
        // 数量范围
        idRange: (min: number, max: number): string => this.get('common.valueRange_label', [min, max]),

        // 提示框相关资料
        prompt: {
            user: {
                delete: {
                    title: this.get('service.accessUser_term_localAuthUser_delete_title'),
                    dangerContent: this.get('service.systemSetting_setShareService_task_deleteLocalUser_info_message'),
                },
            },
            group: {
                delete: {
                    title: this.get('service.accessUser_term_localAuthUserGroup_delete_title'),
                    dangerContent: this.get('service.systemSetting_setShareService_task_deleteLocalUserGroup_info_message'),
                },
            },
        },
        rest: {
            unixUser: {
                create: this.get('rest.createUNIXLocalAuthUser_msg'),
                modify: this.get('rest.modifyUNIXLocalAuthUser_msg'),
                delete: this.get('rest.deleteUNIXLocalAuthUser_msg'),
            },
            unixGroup: {
                create: this.get('rest.createUNIXLocalAuthUserGroup_msg'),
                modify: this.get('rest.modifyUNIXLocalAuthUserGroup_msg'),
                delete: this.get('rest.deleteUNIXLocalAuthUserGroup_msg'),
            },

        },
        error: {
            chooseOne: this.get('common.selectOnlyOneObject_lab'),
            getRequired: (name): string => this.get('common.null_validation', [name]),
            // 名称不符合格式要求，只能包含字母、数字、“_”、“-”、“.”和“$”，并且不能以“-”或“$”开头。"
            accessName: this.get('service.accessUser_format_example_validation'),
        },
        // 冒泡提示资料
        helpIcon: {
            idForUser: this.get('service.accessUser_term_createLocalAuthUser_ID_tip'),
            idForUserGroup: this.get('service.accessUser_term_createLocalAuthUserGroup_ID_tip'),
        },
    };

    constructor(private i18nService: I18nService) { }
}
